import React, { Fragment } from 'react';
import { Grid } from '@material-ui/core';

import { JwlTable, SectionCard, DetailsList } from '..';
import {
  GQLMerchantDeliveryType,
  GQLPlatformMerchantOrder
} from '@jewelutions/core-crm-server-api-client-domain';
import { GQLAddressHelper } from '../../operations/helpers/GQLAddressHelper';
import PlatformMerchantOrderItemListDetails from './PlatformMerchantOrderItemListDetails';

interface IProps {
  order: GQLPlatformMerchantOrder;
}

const PlatformMerchantOrderDetails: React.FC<IProps> = ({ order }: IProps) => {
  const getOrderName = (order: GQLPlatformMerchantOrder) =>
    order.merchantDelivery.deliveryType === GQLMerchantDeliveryType.Warehouse
      ? order.merchantDelivery.warehouseDelivery!.companyName
      : `${order.merchantDelivery.dropshipDelivery!.personFirstName} ${
          order.merchantDelivery.dropshipDelivery!.personLastName
        }`;

  const getOrderLocation = (order: GQLPlatformMerchantOrder) =>
    order.merchantDelivery.deliveryType === GQLMerchantDeliveryType.Warehouse
      ? GQLAddressHelper.addressToString(order.merchantDelivery.warehouseDelivery!.address!)
      : GQLAddressHelper.addressToString(order.merchantDelivery.dropshipDelivery!.address!);

  const orderHistoryColumns = ['Date', 'State', 'Note'];

  const getOrderHistoryRows = () => {
    return order.history.map((history, index) => {
      return {
        id: index,
        cells: [
          new Date(Date.parse(history.createdAt)).toLocaleString(),
          history.state,
          ,
          history.note || '-'
        ]
      };
    });
  };

  return (
    <Fragment>
      <Grid item style={{ marginTop: '8px' }}>
        <SectionCard title="Platform Merchant Order Details">
          <DetailsList
            list={[
              {
                primary: 'ID',
                secondary: order.id
              },
              {
                primary: 'Name',
                secondary: getOrderName(order)
              },
              {
                primary: 'Location',
                secondary: getOrderLocation(order)
              },
              {
                primary: 'State',
                secondary: order.state
              },
              {
                primary: 'Created At',
                secondary: new Date(Date.parse(order.createdAt)).toLocaleString()
              },
              {
                primary: 'Updated At',
                secondary: new Date(Date.parse(order.updatedAt)).toLocaleString()
              }
            ]}
          />
          <JwlTable title="Order History" columns={orderHistoryColumns} rows={getOrderHistoryRows()} />
        </SectionCard>
      </Grid>
      <PlatformMerchantOrderItemListDetails order={order} />
    </Fragment>
  );
};

export default PlatformMerchantOrderDetails;
